import React from 'react';
import { Field } from 'redux-form';
import Document from 'components/document';
import { getVerificationDocumentStatus } from 'helpers/document';
import {} from '../FilesList.types';
const FileItem = ({ input }) => (React.createElement(React.Fragment, null, input.value.status && !input.value.canDelete && (React.createElement(Document, { className: "w-full document margin-bottom--m", documentCreatedDate: input.value.created, documentName: input.value.filename, documentStatus: getVerificationDocumentStatus(input.value), documentURL: input.value.file, hasStatusTag: true, isClearable: false, key: input.value.id }))));
const FileError = ({ file }) => React.createElement(Field, { component: FileItem, name: `${file}`, type: "file" });
export default FileError;
